import React from 'react';
import { Alert as AntAlert, AlertProps } from 'antd';
import {
  CircleInfoIcon,
  CircleCheckIcon,
  CircleExclamationIcon,
  TriangleExclamationIcon,
  XmarkIcon,
} from '@revfluence/fresh-icons/solid';

import cn from 'classnames';
import styles from './Alert.module.scss';

export interface IAlertProps extends AlertProps {
  subAction?: boolean;
}

interface Icons {
  [key: string]: JSX.Element;
}

/**
 * Alert component for feedback.
 */
export const Alert: React.FC<IAlertProps> = (props) => {
  const { banner = true, type = 'info', subAction = false, className } = props;

  const icons: Icons = {
    info: <CircleInfoIcon />,
    success: <CircleCheckIcon />,
    warning: <CircleExclamationIcon />,
    error: <TriangleExclamationIcon />,
  };

  return (
    <AntAlert
      className={cn(styles.Alert, { [styles.subAction]: subAction }, className)}
      banner={banner}
      icon={icons[type]}
      closeIcon={<XmarkIcon />}
      {...props}
    />
  );
};
